export default {
  state: {
    error: null
  },

  mutations: {
    SET_ERROR(state, error) {
      state.error = error
    },
    CLEAR_ERROR(state, error) {
      state.error = null
    }
  },

  actions: {

  },

  getters: {
    getError: state => state.error
  }
}
